/**
 * Normal auth bootstrap must not force-refresh the ID token.
 * getIdToken(false) still returns a valid token and refreshes only if expired.
 * Callers that just wrote custom claims can pass refreshToken: true.
 */
export function resolveAuthTokenForceRefresh(refreshToken?: boolean): boolean {
    return refreshToken === true;
}
